import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { DocumentApproveRequest } from "apis/data-contracts";

interface UseApprovalActionMutation {
  documentUuid: string;
  request: DocumentApproveRequest;
}

export const useApprovalActionMutation = () => {
  return useMutation({
    mutationFn: ({ documentUuid, request }: UseApprovalActionMutation) =>
      api.document.approvalAction(documentUuid, request),
  });
};
